/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';

/**
 * Steam authentication route guard.
 *
 * In order to process a steam authorisation we need to have a steam code.
 *
 * @param to
 * @param from
 * @param next
 */
export const steamAuthenticateReady: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    // code should exist and be a UUID
    if (!to.query.code || !to.query.code.match(/^[a-f0-9]{8}[-]([a-f0-9]{4}[-]){3}[a-f0-9]{12}$/i)) {
        next('/login');
        return;
    }

    next();
};
